/**
 * Triggers a browser download for the given blob by creating a temporary anchor element.
 *
 * The anchor must be appended to the DOM before clicking - otherwise the download does
 * not work in Firefox. The object URL is revoked immediately afterwards to avoid leaking
 * memory.
 */
export function downloadBlob(blob: Blob, fileName: string): void {
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = fileName;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}
